export default __webpack_public_path__ + "static/media/FF00FF.9f311c40.svg";